<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_turno_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Turnos</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group">
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Bloque</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.bloque"
                        placeholder="Bloque"
                        label="nombre"
                        :options="listasForms.bloques"
                        style="font-size: 15px; background-color: #fff"
                        @input="selectBloque()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Transportadora</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.empresa"
                        placeholder="Empresa"
                        label="razon_social"
                        :options="listasForms.empresas"
                        style="font-size: 15px; background-color: #fff"
                        @input="selectEmpresas()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Vehiculo</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.cabezote"
                        placeholder="Placa"
                        label="placa"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.cabezotes"
                        @search="buscarCabezotes"
                        @input="selectVehiculo()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Conductor</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.conductor"
                        placeholder="Conductor"
                        label="nombre"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.conductores"
                        @search="buscarConductor"
                        @input="selectConductor()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Tipo Tarifa</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.t_tarifa"
                        placeholder="Tarifa"
                        label="descripcion"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.t_tarifas"
                        @input="selectTTarifa()"
                        multiple
                        class="col-md-7"
                      >
                      </v-select>
                    </div>

                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Tipo Operacion</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.operacion"
                        placeholder="Tipo Operacion"
                        label="descripcion"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.operaciones"
                        @input="selectOperacion()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Producto</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.producto"
                        placeholder="Nombre"
                        label="nombre"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.productos"
                        @input="selectProducto()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-5" style="font-size: 20px"
                        >Ruta</label
                      >
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.ruta"
                        placeholder="Ruta"
                        label="nombre"
                        style="font-size: 15px; background-color: #fff"
                        :options="listasForms.rutas"
                        @input="selectRuta()"
                        multiple
                        class="col-md-7"
                      ></v-select>
                    </div>

                    <div class="form-group row">
                      <label
                        class="col-md-5"
                        style="font-size: 20px"
                        for="fecha_inicial"
                        >Fecha Inicial</label
                      >
                      <input
                        type="date"
                        v-model="filtros.fecha_inicial"
                        class="form-control form-control-sm col-md-7"
                        @input="validaFechasForm"
                      />
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-5"
                        style="font-size: 20px"
                        for="fecha_final"
                        >Fecha final</label
                      >

                      <input
                        type="date"
                        v-model="filtros.fecha_final"
                        class="form-control form-control-sm col-md-7"
                        @input="validaFechasForm"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre"
                              v-model="form.turno"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombre"
                              >N Turno</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="sitio"
                              v-model="form.vehiculo"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="sitio"
                              >Vehiculo</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="estado1"
                              v-model="form.remolque"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="estado1"
                              >Remolque</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_final_oferta"
                              v-model="form.conductor"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_final_oferta"
                              >Conductor</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="obvs"
                              v-model="form.conductor2"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="obvs"
                              >Segundo conductor</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="observaciones"
                              v-model="form.t_operacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="observaciones"
                              >Tipo Operacion</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="planeaciones_volumenes"
                              v-model="form.t_tarifa"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="planeaciones_volumenes"
                              >Tipo Tarifa</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="bloque"
                              v-model="form.bloque"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="bloque"
                              >Bloque</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="t"
                              v-model="form.transportadora"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="t"
                              >Transportadora</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="ruta"
                              v-model="form.ruta"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="ruta"
                              >Ruta</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="prodcuto"
                              v-model="form.producto"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="prodcuto"
                              >Producto</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_ini"
                              v-model="form.fecha_ini"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fecha_ini"
                              >Fecha Inicial</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_fin"
                              v-model="form.fecha_fin"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="fecha_fin"
                              >Fecha Final</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('tif.turnos.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "TifTurnoExport", //llegada tambien
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      listasForms: {
        bloques: [],
        empresas: [],
        cabezotes: [],
        conductores: [],
        t_tarifas: [],
        operaciones: [],
        productos: [],
        rutas: [],
      },
      filtros: {
        t_tarifa: [],
        t_tarifa_id: [],
        bloque: [],
        operacion_id: [],
        operacion: [],
        bloque_id: [],
        producto_id: [],
        producto: [],
        cabezote: [],
        cabezote_id: [],
        conductor: [],
        conductor_id: [],
        empresa: [],
        empresa_id: [],
        ruta_id: [],
        ruta: [],
        fecha_inicial: null,
        fecha_final: null,
      },
      // 'N Turno, Vehiculo, Remolque,Conductor,Segundo Conductor, Tipo Operacion, Tipo Tarifa, Bloque, Transportadora,Ruta, Producto,Fecha Inicial , Fecha Final'
      form: {
        turno: true,
        vehiculo: true,
        remolque: true,
        conductor: true,
        conductor2: true,
        t_operacion: true,
        t_tarifa: true,
        bloque: true,
        transportadora: true,
        ruta: true,
        producto: true,
        fecha_ini: true,
        fecha_fin: true,
      },
    };
  },

  methods: {
    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/tif/turnos/exportExcel",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    getBloques() {
      axios.get("/api/admin/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },
    selectBloque() {
      this.filtros.bloque_id = this.filtros.bloque.map((e) => e.id);
    },
    getTransportadoras() {
      axios
        .get("/api/admin/empresas/lista", {
          params: {
            linea_negocio_id: [3],
          },
        })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },
    selectEmpresas() {
      this.filtros.empresa_id = this.filtros.empresa.map((e) => e.id);
    },
    validaFechasForm() {
      if (this.filtros.fecha_inicial && this.filtros.fecha_final) {
        const fecha_menor = new Date(this.filtros.fecha_inicial);
        const fecha_mayor = new Date(this.filtros.fecha_final);

        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicio no puede ser mayor a la fecha fin..`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },
    buscarCabezotes(search, loading) {
      if (search != "") {
        let operacion = 0;
        let me = this;
        loading(true);
        var url = "api/tif/inspecciones/buscarcabezote?placa=" + search;
        axios
          .get(url, {})
          .then(function(response) {
            me.listasForms.cabezotes = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    selectVehiculo() {
      this.filtros.cabezote_id = this.filtros.cabezote.map((e) => e.id);
    },
    buscarConductor(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url, {
            params: {},
          })
          .then(function(response) {
            let respuesta = response.data;
            me.listasForms.conductores = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    selectConductor() {
      this.filtros.conductor_id = this.filtros.conductor.map((e) => e.id);
    },
    getTipoTarifa() {
      axios.get("/api/lista/96").then((response) => {
        this.listasForms.t_tarifas = response.data;
      });
    },
    selectTTarifa() {
      this.filtros.t_tarifa_id = this.filtros.t_tarifa.map((e) => e.id);
    },
    getOperacion() {
      axios.get("/api/tif/operaciones/lista").then((response) => {
        this.listasForms.operaciones = response.data;
      });
    },
    selectOperacion() {
      this.filtros.operacion_id = this.filtros.operacion.map((e) => e.id);
    },
    getProductos() {
      let me = this;
      axios
        .get("api/tif/turnos/producto/lista", {
          params: {
            linea_negocio_id: 3,
          },
        })
        .then(function(response) {
          me.listasForms.productos = response.data;
        });
    },
    selectProducto() {
      this.filtros.producto_id = this.filtros.producto.map((e) => e.id);
    },
    getRuta() {
      let me = this;
      axios.get("api/tif/turnos/ruta/lista", {}).then(function(response) {
        me.listasForms.rutas = response.data;
      });
    },
    selectRuta() {
      this.filtros.ruta_id = this.filtros.ruta.map((e) => e.id);
    },
  },
  mounted() {
    this.getBloques();
    this.getTransportadoras();
    this.getTipoTarifa();
    this.getOperacion();
    this.getProductos();
    this.getRuta();
  },
};
</script>
